/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchPreviewLink = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for retrieving the result count
		searchProcessor: null,
		// The search config that was previosly used, for sending the correct click event
		previousConfig: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			var mod = this;
			mod.contentsContainer = mod.$ctx.find('> .contents')[0];
			mod.translations = {
				titleFormat: mod.$ctx.attr('data-translation-title-format')
			};
			mod.linkTitle = mod.$ctx.attr('data-sitesearch-linkTitle');

			// Set the href (except the query)
			var redirectTarget = mod.$ctx.attr('data-sitesearch-redirectTarget');
			var useGetParam = mod.$ctx.data('sitesearchUsegetparam');
			var pivot = useGetParam ? '?' : '#';
			var separator = redirectTarget.indexOf(pivot) > -1 ? '&' : pivot;
			mod.url = redirectTarget + separator;

			mod.$title = mod.$ctx.find('.title-container');
			mod.$container = mod.$ctx.closest('.scs-sitesearch-link-list');

			mod.$ctx.on('click', function() {
				if(!mod.previousConfig) {
					return;
				}
				Module.SearchResultContainer.trackClick('search_other', mod.previousConfig, {
					url: mod.$ctx.prop('href')
				}, mod.searchProcessor);
			});
		},

		initSearch: function(searchContainer) {
			var mod = this;
			mod.searchContainer = searchContainer;
			mod.searchProcessor = SCS.search.orchestration.forResultCount(
				mod.$ctx.attr('data-sitesearch-gsahostname'),
				mod.$ctx.attr('data-sitesearch-sites'),
				mod.$ctx.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de'
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.countReceived
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			// Hide the container (every item will do this)
			this.$container.hide().removeClass('');
			this.process({query: searchConfig.query});
		},

		process: function(config) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		countReceived: function(processor, data, config) {
			this.previousConfig = config;
			this.$ctx.prop('href', this.url + SCS.search.util.param({q: config.query}));
			this.$title.text(
				SCS.utils.formatString(
					this.translations.titleFormat,
					this.linkTitle,
					data.resultCount
				)
			);
			if(data.resultCount > 0) {
				this.$ctx.show();
				// Show the container if at least one item had results
				this.$container.show();
			} else {
				this.$ctx.hide();
			}
		}

	});

	Module.SearchPreviewLink = SearchPreviewLink;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPreviewLink.js
// module id = 68
// module chunks = 0